import "./toast.css";
import { clear, show, config } from './methods';
const Toast = {
  show,
  clear,
  config
};
export default Toast;